import { selectStatus } from '@features/auth/stores/useAuthStore';

type AuthState = Parameters<typeof selectStatus>[0];

interface AuthRequirements {
  allowGuest?: boolean;
}

export function isAuthSatisfied(state: AuthState, requirements: AuthRequirements = {}): boolean {
  if (state.pendingConsents || state.consentsNeeded) return false;
  const status = selectStatus(state);
  if (status === 'authenticated') return true;
  if (status === 'guest' && requirements.allowGuest) return true;
  return false;
}
